export function findId (list, obj, desc) {
    if (list && obj) {
        return list.filter(x => x[desc].toLowerCase() === obj.toLowerCase())[0].id
    }
}

export function findName (list, id, desc) {
    if (list && id) {
        return list.filter(x => x.id === id)[0].desc
    }
}

export function minifyName (name) {
    const splited = name.split(' ')
    return splited[0][0] + splited[1][0]
}
